import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

export default function WindowPortal({ children, onClose, title = "Closer Controls" }) {
  const containerRef = useRef(null);
  const windowRef = useRef(null);

  useEffect(() => {
    const w = window.open("", "closerSidebar", "width=400,height=860,left=80,top=40");
    if (!w) return;
    windowRef.current = w;

    w.document.title = title;

    // Copy all stylesheets from parent
    const parentStyles = document.querySelectorAll('link[rel="stylesheet"], style');
    parentStyles.forEach((node) => {
      w.document.head.appendChild(node.cloneNode(true));
    });

    // Add base styles for the popup body
    const baseStyle = w.document.createElement("style");
    baseStyle.textContent = `
      body { margin: 0; padding: 0; background: #fafafa; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
      * { box-sizing: border-box; }
    `;
    w.document.head.appendChild(baseStyle);

    // Create mount container
    const container = w.document.createElement("div");
    container.id = "popout-root";
    w.document.body.appendChild(container);
    containerRef.current = container;

    // Handle popup close
    w.onbeforeunload = () => {
      if (onClose) onClose();
    };

    // Force re-render after container is ready
    const event = new Event("popout-ready");
    window.dispatchEvent(event);

    return () => {
      if (windowRef.current && !windowRef.current.closed) {
        windowRef.current.close();
      }
    };
  }, []);

  if (!containerRef.current) return null;
  return ReactDOM.createPortal(children, containerRef.current);
}
